import React from 'react';
import { Row, Col, Button, Card, Spinner } from 'react-bootstrap';

const SecuritySettings = ({ onChangePassword, onChangeEmail, onViewLoginHistory, loading }) => {
  return (
    <>
      {loading ? (
        <div className="text-center py-4">
          <Spinner animation="border" role="status" variant="success" size="md" />
          <p className="mt-2">Loading security settings...</p>
        </div>
      ) : (
        <div id="security-mode">
          <Row className="mb-4 justify-content-center">
            <Col xs={12} md={5} className="mb-4 mb-md-0">
              <Card className="security-card h-100">
                <Card.Body className="d-flex flex-column">
                  <div className="text-center mb-3">
                    <div className="security-icon-wrapper">
                      <i className="fas fa-key security-icon"></i>
                    </div>
                    <h5 className="card-title">Password Management</h5>
                  </div>
                  <p className="text-black flex-grow-1">
                    Change your account password to maintain security. We recommend using strong, unique passwords with a mix of letters, numbers, and symbols.
                  </p>
                  <Button
                    variant="success"
                    className="w-100 mt-auto d-flex align-items-center justify-content-center"
                    onClick={onChangePassword}
                  >
                    <i className="fas fa-lock mr-2"></i>
                    <span>Change Password</span>
                  </Button>
                </Card.Body>
              </Card>
            </Col>

            <Col xs={12} md={5}>
              <Card className="security-card h-100">
                <Card.Body className="d-flex flex-column">
                  <div className="text-center mb-3">
                    <div className="security-icon-wrapper">
                      <i className="fas fa-envelope security-icon"></i>
                    </div>
                    <h5 className="card-title">Email Management</h5>
                  </div>
                  <p className="text-black flex-grow-1">
                    Update your email address. This email is used for account recovery, important notifications, and login verification.
                  </p>
                  <Button
                    variant="success"
                    className="w-100 mt-auto d-flex align-items-center justify-content-center"
                    onClick={onChangeEmail}
                  >
                    <i className="fas fa-envelope mr-2"></i>
                    <span>Change Email</span>
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Card className="mb-2">
            <Card.Header className="bg-dark text-white">
              <h5 className="mb-0">Security Recommendations</h5>
            </Card.Header>
            <Card.Body className="p-0">
              <div className="security-tips p-3">
                <ul className="security-recommendations-list">
                  <li className="security-tip mb-3">
                    <div className="d-flex">
                      <div className="tip-icon mr-3">
                        <i className="fas fa-check-circle text-success"></i>
                      </div>
                      <div className="tip-content">
                        <h6 className="mb-1">Use Strong Passwords</h6>
                        <p className="text-black mb-0">
                          Create passwords that are at least 8 characters long and include uppercase letters, lowercase letters, numbers, and special characters.
                        </p>
                      </div>
                    </div>
                  </li>

                  <li className="security-tip mb-3">
                    <div className="d-flex">
                      <div className="tip-icon mr-3">
                        <i className="fas fa-check-circle text-success"></i>
                      </div>
                      <div className="tip-content">
                        <h6 className="mb-1">Keep Your Recovery Email Updated</h6>
                        <p className="text-black mb-0">
                          Ensure your email address is current to receive important security notifications and password reset links.
                        </p>
                      </div>
                    </div>
                  </li>

                  <li className="security-tip mb-3">
                    <div className="d-flex">
                      <div className="tip-icon mr-3">
                        <i className="fas fa-check-circle text-success"></i>
                      </div>
                      <div className="tip-content">
                        <h6 className="mb-1">Save Your 12 Recovery Keys</h6>
                        <p className="text-black mb-0">
                          Store your 12 recovery keys in a safe place. These keys can be used to recover your account if you forget your password.
                        </p>
                      </div>
                    </div>
                  </li>

                  
                </ul>
              </div>
            </Card.Body>
          </Card>

          {/* Future Security Features Card */}
          <Card className="mt-4 coming-soon-card">
            <Card.Body className="text-center p-4">
              <div className="coming-soon-icon mb-3">
                <i className="fas fa-shield-alt"></i>
              </div>
              <h5>Advanced Security Features Coming Soon</h5>
              <p className="text-black mb-0">
                We're working on additional security features including two-factor authentication,
                login notifications, and device management to keep your account even more secure.
              </p>
            </Card.Body>
          </Card>
        </div>
      )}
    </>
  );
};

export default SecuritySettings;